import { useState } from "react";
import CustomButton from "../CustomButton";
import axiosInstance from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import { ParseErrors } from "../../utils/ParseErrors";
import Loader from "../Loader";

interface TDeleteUserModal {
  ToggleDeleteModel: () => void;
  id: number;
  onSuccess?: () => void;
}

const DeleteAgentModel = ({
  ToggleDeleteModel,
  id,
  onSuccess,
}: TDeleteUserModal) => {
  const [isLoading, setIsLoading] = useState(false);

  const deleteUser = async () => {
    setIsLoading(true);
    try {
      const res = await axiosInstance.delete(`/user/delete/${id}`);
      toast.success(res.data.message);
      onSuccess?.();
      ToggleDeleteModel();
    } catch (error) {
      toast.error(ParseErrors(error));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-[99999] flex h-full w-full items-center justify-center overflow-y-auto bg-[rgba(0,0,0,0.5)] p-3 sm:p-4"
      onClick={ToggleDeleteModel}
    >
      <div
        className="w-full max-w-[420px] rounded-2xl border border-edge bg-surface px-5 py-5 shadow-overlay sm:px-8 sm:py-6"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="font-[Gilroy-Bold] text-[20px] text-heading-color sm:text-[24px]">
          Delete this user?
        </h2>
        <p className="mt-2 font-[Gilroy-Medium] text-[14px] text-light-gray">
          This action cannot be undone.
        </p>

        <div className="mt-6 flex flex-col-reverse gap-3 sm:flex-row sm:items-center sm:justify-end">
          <CustomButton
            disabled={isLoading}
            className="!h-[42px] !w-full !rounded-xl !border !border-edge !bg-transparent !px-6 !text-[14px] !font-[Gilroy-Medium] !text-heading-color sm:!w-auto"
            onClick={ToggleDeleteModel}
          >
            Cancel
          </CustomButton>
          <CustomButton
            disabled={isLoading}
            variant="primary"
            className="!h-[42px] !w-full !rounded-xl !px-6 !text-[14px] !font-[Gilroy-Medium] sm:!w-auto"
            onClick={deleteUser}
          >
            {isLoading ? <Loader /> : "Delete"}
          </CustomButton>
        </div>
      </div>
    </div>
  );
};

export default DeleteAgentModel;
